import React from "react";
import MaintainancePic from "../images/hanna-temp.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelopeCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Footer } from "../components/Footer";

interface Props {
  Title: string;
}

const MessageSent = (props: Props): any => {
  return (
    <>
      <div className="wrapper">
        <div className="section">
          <div className="container">
            <div className="row">
              <div className="col-md-6 ml-auto mr-auto text-center">
                <h2 className="title text-center">{props.Title}</h2>
                <p>
                  <FontAwesomeIcon
                    className="center"
                    icon={faEnvelopeCircleCheck}
                    size="6x"
                  />
                </p>
                <hr />
                <p>
                  Thank you, your message has been sent. I will reply to you
                  shortly.
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageSent;
